import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { SESSION_CAM_EXCLUDE } from "../../../constants/sessioncam";

const styles = ({ theme }) => ({
  label: {
    "user-select": "none",
    fontFamily: theme.fonts.serif,
    fontWeight: theme.fontWeights.medium,
    cursor: "pointer",
    marginLeft: -1,
    fontSize: 16,
    display: "inline-block",
    "&:first-of-type": {
      marginLeft: 0,
      borderTopLeftRadius: theme.borderRadius.sm,
      borderBottomLeftRadius: theme.borderRadius.sm
    },
    "&:last-of-type": {
      borderTopRightRadius: theme.borderRadius.sm,
      borderBottomRightRadius: theme.borderRadius.sm
    }
  },
  input: {
    border: "0 !important",
    clip: "rect(0 0 0 0) !important",
    height: "1px !important",
    margin: "-1px !important",
    overflow: "hidden !important",
    padding: "0 !important",
    position: "absolute !important",
    width: "1px !important",
    appearance: "none",
    "&::-ms-check": {
      appearance: "none"
    },
    "&:checked + $button": {
      color: theme.colors.tertiary1,
      backgroundColor: theme.colors.quanternary2,
      //   borderColor: theme.colors.quanternary2,
      position: "relative",
      zIndex: 2
    },
    "&:disabled:checked + $button": {
      color: theme.colors.tertiary1,
      backgroundColor: theme.colors.primary3
    },
    "&:focus + $button": {
      boxShadow: [0, 0, 6, theme.colors.quanternary2],
      //   borderColor: theme.colors.primary1,
      position: "relative",
      zIndex: 2
    },
    "&:disabled + $button": {
      color: theme.colors.primary3,
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.primary3
    }
  },
  separated: {
    fontFamily: theme.fonts.serif,
    margin: [0, 5],
    borderRadius: theme.borderRadius.full,
    "&:first-of-type, &:last-of-type": {
      borderRadius: theme.borderRadius.full
    },
    "&:first-of-type": {
      marginLeft: 0
    }
  },
  button: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    height: 40,
    paddingLeft: 20,
    paddingRight: 20,
    margin: 0,
    float: "left",
    whiteSpace: "nowrap",
    color: theme.colors.secondary1,
    backgroundColor: theme.colors.white,
    border: {
      width: theme.width.px,
      style: "solid",
      color: theme.colors.primary5
    },
    borderRadius: "inherit",
    "&:hover": {
      backgroundColor: props => (props.disabled ? null : null)
    }
  },
  buttonError: {
    color: `${theme.colors.tertiary2} !important`, // need to override pseudo styles
    backgroundColor: `${theme.colors.white} !important`,
    borderColor: theme.colors.tertiary2
  }
});

const FormInputToggleButton = React.forwardRef(
  (
    {
      id,
      value,
      label,
      classes,
      checked,
      disabled,
      invalid,
      separated,
      onChange,
      sessionCamExclude,
      ...rest
    },
    ref
  ) => {
    const buttonClasses = classNames(classes.button, {
      [classes.buttonError]: invalid
    });
    return (
      <label
        htmlFor={id}
        className={classNames(classes.label, {
          [classes.separated]: separated,
          [SESSION_CAM_EXCLUDE]: sessionCamExclude
        })}
      >
        <input
          ref={ref}
          disabled={disabled}
          id={id}
          value={value}
          type={"radio"}
          className={classes.input}
          checked={checked}
          onChange={onChange}
          {...rest}
        />
        <div className={buttonClasses}>{label}</div>
      </label>
    );
  }
);
FormInputToggleButton.displayName = "FormInputToggleButton";
FormInputToggleButton.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  /** Indicates if this field has been excluded from recording by sessioncam */
  sessionCamExclude: PropTypes.bool
};

export default injectSheet(styles, { inject: ["classes"] })(
  FormInputToggleButton
);
